<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.45 38.3283L9.6717 35.55L21.2217 24L9.6717 12.45L12.45 9.6717L24 21.2217L35.55 9.6717L38.3283 12.45L26.7783 24L38.3283 35.55L35.55 38.3283L24 26.7783L12.45 38.3283Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
